import { useState } from "react";
import { ChevronDown, Table2 } from "lucide-react";

import { reais, rotuloGrupo } from "../lib/formato";

/** A mesma série do gráfico em números — grupo sem movimento fica escondido. */
export default function TabelaFluxo({ dados }) {
  const [aberta, setAberta] = useState(false);
  const serie = (dados?.serie || []).filter((l) => l.entradas_realizadas || l.entradas_previstas || l.saidas_realizadas || l.saidas_previstas);
  if (!serie.length) return null;
  const agrupar = dados.periodo.agrupar;
  const mostrar = aberta ? serie : serie.slice(0, 8);
  return (
    <section className="rounded-2xl border bg-card overflow-hidden" data-e2e="tabela-fluxo">
      <div className="px-4 sm:px-5 py-3 border-b flex items-center gap-2">
        <Table2 className="w-4 h-4 text-primary" /><h2 className="font-bold">Dia a dia</h2>
        <span className="text-xs text-muted-foreground">({serie.length} com movimento)</span>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-muted/50 text-[11px] uppercase tracking-wider text-muted-foreground">
            <tr><th className="text-left px-4 py-2">Quando</th><th className="text-right px-3">Entradas</th><th className="text-right px-3">Saídas</th><th className="text-right px-3">Resultado</th><th className="text-right px-4">Saldo</th></tr>
          </thead>
          <tbody>
            {mostrar.map((l) => {
              const ent = l.entradas_realizadas + l.entradas_previstas;
              const sai = l.saidas_realizadas + l.saidas_previstas;
              return (
                <tr key={l.data} className={`border-t ${l.futuro ? "text-muted-foreground" : ""}`}>
                  <td className="px-4 py-2 whitespace-nowrap">{rotuloGrupo(l.data, agrupar)}{l.futuro && <span className="ml-2 text-[10px] px-1.5 py-0.5 rounded bg-muted uppercase font-semibold">previsto</span>}</td>
                  <td className="px-3 text-right tabular-nums text-emerald-700 dark:text-emerald-400">{ent ? reais(ent) : "—"}</td>
                  <td className="px-3 text-right tabular-nums text-red-600 dark:text-red-400">{sai ? reais(-sai) : "—"}</td>
                  <td className="px-3 text-right tabular-nums font-medium">{reais(ent - sai)}</td>
                  <td className={`px-4 text-right tabular-nums font-semibold ${l.saldo < 0 ? "text-red-600 dark:text-red-400" : "text-foreground"}`}>{reais(l.saldo)}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      {serie.length > 8 && (
        <button type="button" onClick={() => setAberta((v) => !v)} className="w-full py-2.5 text-xs font-medium text-primary hover:bg-muted/40 flex items-center justify-center gap-1 border-t">
          {aberta ? "Mostrar menos" : `Ver todos os ${serie.length}`}<ChevronDown className={`w-3.5 h-3.5 transition-transform ${aberta ? "rotate-180" : ""}`} />
        </button>
      )}
    </section>
  );
}
